const transport = [
  { value: "FLIGHT", label: "Airplane" },
  { value: "BUS", label: "Bus" },
  { value: "OWN", label: "Own" },
];

export default transport;
